import React, {useEffect, useState} from 'react';
import connection from '../../../connection';
import {NotificationManager} from 'react-notifications';
import {Col, Container, Row, Button} from 'react-bootstrap';
import ScaleLoader from 'react-spinners/ScaleLoader';
import {useAuth} from '../../../contexts/authContext';
import {useHistory} from "react-router-dom";
import {Trans, useTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header/Header';
import BulletHeader from '../../../components/BulletHeader/BulletHeader';
import ReplicateCard from '../../../components/ReplicateCard/ReplicateCard';

// CSS Files
import './styles.css';

const override = `
    display: block;
    text-align: center;
    margin-top: 10%;
`;

const ReplicateEnrollments = (props) => {
   const [oldTournamentEnrollments, setOldTournamentEnrollments] = useState([]);
   const [oldLeagueEnrollments, setOldLeagueEnrollments] = useState([]);
   const [loading, setLoading] = useState(true);
   const auth = useAuth();
   const history = useHistory();
   const { t } = useTranslation();

   useEffect(() => {
      (async () => {
         if (!auth.checked) {
            return;
         }

         if (!auth.user) {
            if (props.formData.isLeague) {
               history.push('/login');
            } else {
               setLoading(false);
            }
            return;
         }

         if (props.formData.isLeague) {
            await loadOldLeagueEnrollments();
         } else {
            await loadOldTournamentEnrollments();
         }
         setLoading(false);
      })();
   }, [auth.checked, auth.user]);

   let loadOldLeagueEnrollments = async () => {
      try {
         let oldLeagueEnrollments = await connection.get('v1/current_user/enrollments/old_league_enrollments');
         setOldLeagueEnrollments(oldLeagueEnrollments.enrollments);
      } catch (e) {
         NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
      }
   };

   let loadOldTournamentEnrollments = async () => {
      try {
         let oldTournamentEnrollments = await connection.get('v1/current_user/tournament_enrollments/old_tournament_enrollments');
         setOldTournamentEnrollments(oldTournamentEnrollments.enrollments);
      } catch (e) {
         NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
      }
   };

   let header = null;
   if (props.formData.isLeague) {
      header = <BulletHeader text={t("registration_page.replicate_registration_league")}/>;
   } else {
      header = <BulletHeader text={t("registration_page.replicate_registration_tournament")}/>;
   }

   let submit = (data) => {
      props.formData.user_registration = undefined;
      props.formData.partner_registration = undefined;
      props.onSubmit(data);
   };
   return (
      <div>
         <Header headerBarTitle={t("registration_page.header")} showHeaderExtras showBackButton/>

         <Container className={'pb-5 desktop'}>
            <Row>
               <Col xs={12}>
                  <Button className={'w-100'} variant="primary" onClick={() => {
                     let is_replication = false;
                     submit({is_replication: is_replication});
                  }}>{t("registration_page.new_registration")}</Button>
               </Col>
            </Row>
            <Row>
               <Col xs={12}>{header}</Col>
            </Row>
            <Row>
               <Col className={'pb-3'} xs={12} sm={12}>
                  <p><Trans i18nKey="registration_page.replicate_registration_alert" components={{ br: <br /> }} /></p>
               </Col>
            </Row>
            <Row>
               <Col xs={12}>
                  <ScaleLoader
                     css={override}
                     sizeUnit={'px'}
                     size={30}
                     color={'#afff55'}
                     loading={loading}
                  />
                  {!loading && ((props.formData.isLeague && oldLeagueEnrollments.length === 0) || (!props.formData.isLeague && oldTournamentEnrollments.length === 0)) &&
                     <div className="alert alert-info" role="alert">{t("registration_page.no_old_registrations")}</div>
                  }
               </Col>

               {!loading && props.formData.isLeague && oldLeagueEnrollments.map((item, i, arr) => {
                  let lastItem = ((arr.length - 1) === i);
                  let teamName = ` - ${item.player_a_name} / ${item.player_b_name}`;
                  if (item.player_a_name !== undefined || item.player_b_name !== undefined)
                     return <ReplicateCard key={item.enrollment_id} leagueName={item.league_name + ' - ' + item.league_edition_name} lastItem={lastItem} category={item.league_category} teamPlayers={teamName} onClick={() => {
                        let is_replication = true;
                        let replication_is_league = true;
                        submit({clubs: item.clubs, is_replication, replication_is_league, category: item.league_category, enrollment_id: item.enrollment_id, league_category_id: item.league_category_id});
                     }}/>;
               })}

               {!loading && !props.formData.isLeague && oldTournamentEnrollments.map((item, i, arr) => {
                  let lastItem = ((arr.length - 1) === i);
                  let teamName = item.player_a_name + ' e ' + item.player_b_name;

                  if (item.player_a_name !== undefined || item.player_b_name !== undefined)
                     return <ReplicateCard key={item.enrollment_id} leagueName={item.tournament_name} lastItem={lastItem} teamPlayers={teamName} onClick={() => {
                        let is_replication = true;
                        let replication_is_league = false;
                        submit({is_replication, replication_is_league, category: item.category, enrollment_id: item.enrollment_id});
                     }}/>;
               })}

            </Row>
         </Container>

      </div>);
};

export default ReplicateEnrollments;
